import { HOT_LIST, HOT_WORDS } from "@/mocks/contents";

function tagClass(tag: string) {
  if (tag === "爆") return "bg-primary-500 text-background-50";
  if (tag === "沸") return "bg-primary-100 text-primary-800";
  if (tag === "热") return "bg-secondary-100 text-secondary-900";
  if (tag === "新") return "bg-accent-100 text-accent-800";
  return "bg-background-200 text-foreground-700";
}

export default function HotRanking() {
  return (
    <section id="hotlist" className="w-full bg-background-50 py-12 md:py-16" aria-label="热榜速递">
      <div className="mx-auto w-full max-w-7xl px-4 md:px-6">
        <div className="flex flex-col justify-between gap-4 md:flex-row md:items-end">
          <div>
            <span className="text-xs font-bold tracking-[0.2em] text-accent-600">HOT · 热榜速递</span>
            <h2 className="mt-2 font-heading text-3xl font-black text-foreground-950 md:text-4xl">
              今日实锤热榜
            </h2>
            <p className="mt-3 max-w-xl text-sm leading-relaxed text-foreground-600">
              按全网讨论度与更新速度聚合的实时榜单，热度每 10 分钟刷新一次，标题即线索，点进对应分区查看完整梳理。
            </p>
          </div>
          <p className="inline-flex items-center gap-2 whitespace-nowrap text-sm font-medium text-foreground-500">
            <i className="ri-refresh-line text-accent-600" aria-hidden="true"></i>
            最近更新：刚刚
          </p>
        </div>

        <div className="mt-8 grid grid-cols-1 gap-6 lg:grid-cols-3">
          <ol className="rounded-2xl border border-background-200 bg-background-50 p-2 lg:col-span-2">
            {HOT_LIST.map((item, idx) => (
              <li key={idx}>
                <a
                  href="#gallery"
                  className="flex cursor-pointer items-center gap-4 rounded-xl px-3 py-3.5 transition-colors hover:bg-background-100"
                >
                  <span
                    className={`font-heading w-8 shrink-0 text-right text-xl font-black ${
                      idx < 3 ? "text-primary-600" : "text-foreground-300"
                    }`}
                  >
                    {idx + 1}
                  </span>
                  <span className={`h-5 w-px shrink-0 ${idx < 3 ? "bg-primary-300" : "bg-background-200"}`} aria-hidden="true"></span>
                  <span className="min-w-0 flex-1">
                    <span className="line-clamp-2 text-sm font-medium leading-snug text-foreground-900">{item.title}</span>
                  </span>
                  <span className={`hidden shrink-0 rounded px-2 py-0.5 text-xs font-bold sm:inline-flex ${tagClass(item.tag)}`}>
                    {item.tag}
                  </span>
                  <span className="hidden shrink-0 text-xs text-foreground-500 md:inline">{item.heat}</span>
                  <span
                    className={`flex h-6 w-6 shrink-0 items-center justify-center rounded-full ${
                      item.up ? "bg-accent-100 text-accent-700" : "bg-background-200 text-foreground-500"
                    }`}
                  >
                    <i className={`text-xs ${item.up ? "ri-arrow-up-line" : "ri-arrow-down-line"}`} aria-hidden="true"></i>
                  </span>
                </a>
              </li>
            ))}
          </ol>

          <aside className="flex flex-col gap-5" aria-label="榜单侧栏">
            <div className="rounded-2xl border border-background-200 bg-background-100 p-6">
              <h3 className="font-heading text-lg font-bold text-foreground-950">热门话题关键词</h3>
              <p className="mt-1 text-xs text-foreground-500">点击可跳转对应分类图文</p>
              <div className="mt-4 flex flex-wrap gap-2">
                {HOT_WORDS.map((w) => (
                  <a
                    key={w}
                    href="#gallery"
                    className="cursor-pointer whitespace-nowrap rounded-full bg-background-50 px-3 py-1.5 text-xs font-medium text-foreground-700 ring-1 ring-background-200 transition-colors hover:bg-accent-500 hover:text-background-50 hover:ring-accent-500"
                  >
                    {w}
                  </a>
                ))}
              </div>
            </div>

            <div className="rounded-2xl border border-background-200 bg-background-100 p-6">
              <div className="flex items-center gap-2">
                <i className="ri-user-voice-line text-lg text-primary-600" aria-hidden="true"></i>
                <h3 className="font-heading text-base font-bold text-foreground-950">热度口径说明</h3>
              </div>
              <p className="mt-3 text-xs leading-relaxed text-foreground-600">
                榜单热度综合平台讨论量、媒体转载数与跟进速度加权得出，仅代表网络关注程度，不构成对事件真伪的判定。详情请查看对应「深度盘点」。
              </p>
              <a
                href="#faq"
                className="mt-4 inline-flex cursor-pointer items-center gap-1 text-sm font-semibold text-primary-700 hover:text-primary-600"
              >
                了解内容原则
                <i className="ri-arrow-right-line text-sm" aria-hidden="true"></i>
              </a>
            </div>
          </aside>
        </div>
      </div>
    </section>
  );
}